import React from "react";
import { DataTable } from "./DataTable";
import { Button, message } from "antd";
import { useIntroductionsModel } from "../introductionsModel";
import { YhBox } from "@/components/YhBox";

export const DataBox = () => {
    const { setIIntroductionsDrawer, selectedRowKeys, disableIntroductions } = useIntroductionsModel();

    const action = <>
        {/* <YhAuth resCode={ResourceAuthEnum.ORG_SHOP_AD}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => setIIntroductionsDrawer("add")}
        >新增</Button>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.ORG_SHOP_ED}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据进行操作");
                    return;
                }
                setIIntroductionsDrawer("edit");
            }}
        >编辑</Button>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.ORG_SHOP_ED}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据进行操作");
                    return;
                }
                setIIntroductionsDrawer("look");
            }}
        >查看</Button>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.ORG_SHOP_ED}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                // if (!selectedRowKeys.length) {
                //     message.warning("请选择你要操作的数据");
                //     return;
                // }
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据进行操作");
                    return;
                }
                disableIntroductions(selectedRowKeys[0])
            }}
        >删除</Button>
        {/* </YhAuth> */}
    </>;

    return (
        <YhBox action={action}>
            <DataTable />
        </YhBox>
    )
}